import React from 'react';

export default function HomeToOtherPage({ setPage }) {
  return (
    <>
      {/* 第一塊：左圖右文 */}
      <div style={{...styles.wrapper, 
                  background: '#BED5DD',
                  color:'#05193F'}}>
        <div style={styles.imageBox}>
          <img
            src="/assets/pathology.png"
            alt="fig-pathology"
            style={styles.image}
          />
        </div>
        <div style={styles.textBox}>
          <h2 style={styles.title}>Automated Individual Medical Record Analysis</h2>
          <p style={styles.paragraph}>Upload a medical report, and the system leverages large language models to automatically summarize, structure, and organize key clinical information for easier interpretation.
</p>
          <button onClick={() => setPage('pathologic')} 
            style={{...styles.button, 
                    border:'2px solid #014298',
                    color: '#014298'}}>
            Start pathological analysis
          </button>
        </div>
      </div> 

      {/* 第二塊：右圖左文 */}
      <div style={{ ...styles.wrapper, 
                    flexDirection: 'row-reverse',
                    background: '#BCC0DD',
                    color: '#05193F'}}>
        <div style={styles.imageBox}>
          <img
            src="/assets/cohort.png"
            alt="fig-cohort"
            style={styles.image}
          />
        </div>
        <div style={styles.textBox}>
          <h2 style={styles.title}>Comparative Cohort Analysis</h2>
          <p style={styles.paragraph}>Automatically identifies survival endpoints and covariates from cohort data, then produces reproducible statistical analyses (CoxPH/KM and group comparisons) with exportable figures and tables.</p>
          <button onClick={() => setPage('cohort')} 
            style={{...styles.button,
                    border:'2px solid #7311A6',
                    color: '#7311A6'}}>
            Start cohort analysis
          </button>
        </div>
      </div>
      {/* 第三塊：左圖右文 */}
      <div style={{...styles.wrapper, 
                  background: '#BED5DD',
                  color:'#05193F'}}>
        <div style={styles.imageBox}>
          <img
            src="/assets/multi-report.png"
            alt="fig-pathology"
            style={styles.image}
          />
        </div>
        <div style={styles.textBox}>
          <h2 style={styles.title}>Automated Multi-case Medical Record Structuring</h2>
          <p style={styles.paragraph}>The system converts unstructured medical reports into a structured dataset using LLMs, with transparent source references and full user control over field names and content.</p>
          <button onClick={() => setPage('multicase')} 
            style={{...styles.button, 
                    border:'2px solid #014298',
                    color: '#014298'}}>
            Start multi-report structuring
          </button>
        </div>
      </div>
    </>
  );
}



const styles = {
  wrapper: {
    display:'flex',
    padding: '60px 20px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  imageBox: {
    flex: '1',
    textAlign: 'center',
    padding: '20px',
    maxWidth: '800px'
  },
  image: {
    width: '400px',
    borderRadius: '16px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.3)'
  },
  textBox: {
    flex: '1',
    padding: '60px',
    maxWidth: '500px'
  },
  title: {
    fontSize: '2rem',
    fontWeight: '700',
    marginBottom: '20px'
  },
  paragraph: {
    fontSize: '1.2rem',
    marginBottom: '16px',
    color: '#05193F'
  },
  button: {
    padding: '12px 26px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '12px',
    fontSize: '16px'
  }
};